var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightbite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.5,214.3c-2.7,3.5-7,3-10.5,3.3c-7.5,0.6-15.5,1.6-20.5-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.5,222.3c-2.2,3.3-2.1,7.5-3.9,11.1c-3.6,7.3-10.1,8.7-17.1,9.4c-3.1,0.3-6.4-0.3-9.5,0.1 c-9.4,1.3-18.4-7.3-18.6-16.6c0-0.5-0.6-1-1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.5,198.3c-3.5-3.5-4.6-8.1-6-12.5c-1.1-3.6-2.6-7.1-5.1-10c-4.9-5.9-14.3-7.2-18.1,3.4 c-2.1,5.9-1.8,12.2-3.9,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.5,216.8c-2.6,9.9-3.9,20.3-9.1,29c-6.7,0.1-7.4-5.1-9.9-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,218.8c3.2,0,6.6,1.1,8.6-3c1.6-3.1,4.4-2.2,6.9-1c0.6,0.3,1,1,1.5,1.5c7.7,5.6,18.1,3.4,22.4-5 c1.7-3.3,0.7-7.2-0.5-10.4c-3.5-9.6-10.9-14.4-20.9-15.6c-7.3-0.9-14.3-0.6-19,6.1c-4.1,5.9-6.4,17.3-1,25c0.8,1.1,1.2,1.8,1.2,3.5 c-0.5,8.9,4.8,17.2,15.8,20c2.1,0.5,4.3,0.7,6.5,1c10,1.5,16.9-2.8,21.5-11.5c1.2-2.3,2.9-4.4,4.5-6.9c-3.6-2.4-6.2-5.8-7.6-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.5,209.3c3.5,5.2,9.8,6.2,14.5,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.5,214.8c-1.3,8.5-3.6,16.8-7.1,24.7c-3-1.5-4.2-2.5-3.2-6.3c1.5-5.8,3.4-11.5,4.3-17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,197.3c-2-4-4.3-7.9-5.9-12c-1.1-2.7-2.9-4.5-5.1-5.9c-4.7-3.1-8.9-1.8-12.1,2.9 c-3.3,4.9-2.8,10.9-4.9,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,217.8c-1.5,8.3-1.3,17-6,24.5c-3.8,6-7.1,5.7-11.6,0.1c-4.1-5.1-4.4-10.3-2.8-16.1 c0.7-2.5,0.3-5,0.5-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,222.3c5.1,1.3,9.1,0,11.5-5c1.9-3.9,5.1-2.6,8-1.5c7.9,3.1,10,2.7,15.5-3.5c2.4-2.8,2.7-11.5,0.5-14.5 c-2.7-3.6-5.2-7.5-8-11c-8-9.9-24.3-8.3-30.4,3c-1.8,3.3-3,7-4.5,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.5,237.8c-1.1,1.6-2.1,3.2-3.3,4.9c-2.1-0.5-1.8-3.2-3.2-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.5,228.3c0.7,1.8,1.5,3.6,2,5.5c1.8,8,6.2,13.5,14,16.6c7.9,3.2,9.8,0.6,12.2-5c1-2.4,0-5.1,1.9-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.5,205.8c-4.1,2.5-7.2,6.1-10.5,9.5c-2.1,2.2-4.5,3.6-7.6,3.9c-3.1,7-5.2,14.3-7.6,21.5 c-1.6,4.7-6.2,5.7-10.9,5.5c-5-0.2-7-4-8.5-8c-1.9-5.3-3.4-10.6-5-16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210,198.3c3.5,7.7,0.9,12.6-6.5,17.5c-2.9,1.9-6.5,2.3-9.3,4.8c-5.4-1.1-10.4-3.6-13.7-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.5,182.3c1.5-4.9,0.8-10.4,3.9-15.1c4.1-6.3,6.1-4.6,10.1-1.4c5.1,4.1,7.8,10,11,15.5 c4.7,8.1,8.6,16.6,11.5,25.5c1.5,4.5,0.6,6.5-4,7.4c-6.7,1.3-13.5,3.1-20.5,1.6c-1.9-0.4-3.9-0.8-3.9-3c0-6.4-3-11.8-5.1-17.5 c-2.8-7.8-5.3-15.6-8.9-23c-1.6-3.3-2.8-7.3-7.1-7.3c-4.1-0.1-5.7,3.7-7.5,6.8c-2.3,3.8-3.3,8-4.8,12.1c-1.7,4.4,1,8.7,2,12.9 c4.2,17.3-8.9,24.1-21.1,23c-3.7-0.4-6.8-2.7-9.4-5c-2.9-2.5-5.5-5.7-7.5-9c-1.6-2.6-2.1-5.7-0.7-9c1.7-3.8,1.8-7.8,1.2-12 c-0.5-3.6-0.3-7.3,0.8-11c3-10.3,12.3-11.1,18.5-7.8c6.4,3.3,10.9,9,13.6,15.8c0.4,1,0.7,2.2,2,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.5,220.3c-2.3,7.3-4.9,14.6-6.9,22c-1.2,4.5-3.2,7.9-8.1,8.4c-4.7,0.5-8.4-1.4-11-5.4 c-3.9-6.1-5.3-13.1-6.9-20c-0.2-0.8-0.5-1.5-1.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345,211.3c7.1,0.6,9.5-1.8,8.4-9.5c-2.2-16.2-9.6-29.7-21.9-40.5c-0.4-0.3-0.9-0.5-1.4-0.7 c-4,2.3-1.1,7.2-4.1,9.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbite);
export default __webpack_public_path__ + "static/media/rightbite.d815f1b59aaaa3d944f28c82e8b4f780.svg";
export { ForwardRef as ReactComponent };